import {
  PaymentPolicyType,
  type CancellationPolicy,
  type ReservationLocation,
} from '@wix/ambassador-table-reservations-v1-reservation-location/types'

export type EffectiveProtectionMethod = 'NO_PAYMENT_METHOD' | 'PREPAYMENT' | 'CARD_GUARANTEE'

/**
 * Protection is active when the location (or reservation snapshot) has a cancellationFee
 * and the party size meets the fee's minPartySize threshold.
 * Config-driven only — never gated on the tableReservationsCancellationFee flag in OOI.
 */
export function isProtectionActive(
  cancellationPolicy: CancellationPolicy | undefined | null,
  partySize?: number | null,
): boolean {
  const fee = cancellationPolicy?.cancellationFee
  if (!fee) return false

  const minPartySize = fee.minPartySize ?? 1
  return (partySize ?? 0) >= minPartySize
}

/**
 * Derive the effective protection method from cancellationFee presence and whether the location
 */
export function effectiveProtectionMethod(
  cancellationPolicy: CancellationPolicy | undefined | null,
  hasPrepayment: boolean,
  partySize?: number | null,
): EffectiveProtectionMethod {
  if (!isProtectionActive(cancellationPolicy, partySize)) return 'NO_PAYMENT_METHOD'
  if (hasPrepayment) return 'PREPAYMENT'
  return 'CARD_GUARANTEE'
}

export function hasPrepayment(reservationLocation?: ReservationLocation): boolean {
  const type = reservationLocation?.configuration?.paymentPolicy?.paymentPolicyType
  return type === PaymentPolicyType.PER_GUEST || type === PaymentPolicyType.PER_RESERVATION
}
